import { render, staticRenderFns } from "./footer-slider-phone.vue?vue&type=template&id=a88f2bac&scoped=true&"
import script from "./footer-slider-phone.vue?vue&type=script&lang=js&"
export * from "./footer-slider-phone.vue?vue&type=script&lang=js&"
import style0 from "./footer-slider-phone.vue?vue&type=style&index=0&id=a88f2bac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88f2bac",
  null
  
)

export default component.exports